// extracted by css-extract-rspack-plugin
export default {"Icon":"Icon-XbcxZH","icon":"Icon-XbcxZH"};